/**
 * The role that gates the GIS management feature. Must match roles.name exactly.
 *
 * One shared constant rather than a string literal repeated between the route definition and the
 * side nav, because those two places disagreeing is silent: the tab disappears while the route
 * still works, or the reverse.
 *
 * An `as const` object, following SINGLE_VIEW_ROLES in single-view.model.ts. There is no enum
 * anywhere in this codebase and no application-wide roles constants file; introducing one would be
 * a refactor across app-routing.module.ts and side-nav.component.ts, which is its own piece of work.
 */
export const GIS_ROLES = {
  GISPersonnel: 'GISPersonnel'
} as const;

/**
 * Every role permitted onto the GIS route.
 *
 * <strong>Do not add 'AngularField', 'AngularProfile' or 'AngularPinManager' to this array.</strong>
 * auth.guard.ts:96-100 iterates the route's shouldHaveRoles and sets hasAccess = true for any of
 * those three with no role lookup at all, and the real role check that follows can only ever ADD
 * access - it never revokes the short-circuit. So including any of them here would silently grant
 * the GIS screens, and their cross-tenant data, to every logged-in user.
 */
export const GIS_ROUTE_ROLES: string[] = [GIS_ROLES.GISPersonnel];
